import { useMemo } from 'react';

import { ProgressIndicatorItemSingleModified } from './useProgressIndicator';

const ProgressIndicatorSingleIndicator: React.FunctionComponent<ProgressIndicatorItemSingleModified> =
  function ({ active, passed, last }) {
    const bgColor = useMemo(() => {
      if (passed) return 'bg-purple-300';
      if (active) return 'bg-neutral-900';
      return 'bg-neutral-400';
    }, [passed, active]);

    const className = useMemo(
      () => ['h-1.5 flex-[1_1_0]', bgColor].join(' '),
      [bgColor],
    );

    const separatorClassName = useMemo(
      () =>
        [
          'h-1.5 w-px',
          passed ? 'bg-purple-300' : 'bg-neutral-500',
          last ? 'hidden' : 'block',
        ].join(' '),
      [passed, last],
    );

    return (
      <>
        <div className={className} />
        <div className={separatorClassName} />
      </>
    );
  };

export default ProgressIndicatorSingleIndicator;
